
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import TasksListView from "./tasks-list.html";

angular.module("tasks", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('tasks', {
                url: "/tasks",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('tasks.list', {
                url: "/list/:entity_type/:entity_type_id",
                controller: "TasksListCtrl", 
                template: TasksListView,
                cache: false,
                resolve: {
                    entity_type: ['$stateParams', 'logService', function ($stateParams, logService) {
                        logService.debug($stateParams.entity_type);
                        if (angular.isDefined($stateParams.entity_type) && $stateParams.entity_type != "") {
                            return $stateParams.entity_type;
                        }
                        return null;
                    }],
                    entity_type_id: ['$stateParams', 'logService', function ($stateParams, logService) {
                        if (angular.isDefined($stateParams.entity_type_id) && $stateParams.entity_type_id != "") {
                            return $stateParams.entity_type_id;
                        }
                        return null;
                    }]
                },
                requiredPermission: ["TASKS_READ"]
            })
    }])
    ;